export default __webpack_public_path__ + "static/media/Instagram.6cb60c08.svg";